<template>
  <div class='bg-abstract block-fullscreen' :class="{ 'is-mobile': mobile }">
    <div class='header-logo' id='headerLogo'>
      <icon name='td-logo' color='#393f49' />
    </div>
    <section class='block-fullscreen-center result-page'>
      <div id='fullpage'>
        <!-- Overall -->
        <section class='section'>
          <div class='result-percentage result-big bg-abstract-float'>
            <h1 class='title-main'>{{ resultText.overall.title }}</h1>
            <div class='number-float'>{{ initResults.td_score_overall }}%</div>
          </div>
          <a :href='`#${slidesNames[1]}`' class='nav-arrow-down'>
            <div class='title hidden-xs hidden-sm'>
              Role para baixo
            </div>
            <icon name='arrow-line-right' class='arrow-right animation-blink' />
          </a>
        </section>
        <!-- Geral -->
        <section class='section'>
          <div class='result-bar'>
            <div class='description' v-html='resultText.overall.text'></div>
            <div class="categories-bars">
              <div class='category-bar'>
                <div class='category'>Pessoas</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.td_score_people)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.td_score_people }}%</div>
              </div>
              <div class='category-bar'>
                <div class='category'>Processos</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.td_score_process)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.td_score_process }}%</div>
              </div>
              <div class='category-bar'>
                <div class='category'>Cliente</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.td_score_customer_experience)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.td_score_customer_experience }}%</div>
              </div>
              <div class='category-bar'>
                <div class='category'>Estratégia</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.td_score_strategy)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.td_score_strategy }}%</div>
              </div>
            </div>
          </div>
          <a :href='`#${slidesNames[2]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a>
        </section>
        <!-- Category 1 -->
        <section class='section result-categories'>
          <div class='result-category'>
            <div class='category'>Pessoas</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.people.title }}</h2>
              <div class='number-float' id='resultPeople'>{{ initResults.td_score_people }}%</div>
            </div>
            <div class='result-description' v-html='resultText.people.text'></div>
          </div>
          <div class='result-category'>
            <div class='category'>Processos</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.process.title }}</h2>
              <div class='number-float' id='resultProcess'>{{ initResults.td_score_process }}%</div>
            </div>
            <div class='result-description' v-html='resultText.process.text'></div>
          </div>
          <a :href='`#${slidesNames[3]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a>
        </section>
        <!-- Category 2 -->
        <section class='section result-categories'>
          <div class='result-category'>
            <div class='category'>Exp. do Consumidor</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.customer_experience.title }}</h2>
              <div class='number-float' id='resultPeople'>{{ initResults.td_score_customer_experience }}%</div>
            </div>
            <div class='result-description' v-html='resultText.customer_experience.text'></div>
          </div>
          <div class='result-category'>
            <div class='category'>Estratégia</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.strategy.title }}</h2>
              <div class='number-float' id='resultProcess'>{{ initResults.td_score_strategy }}%</div>
            </div>
            <div class='result-description' v-html='resultText.strategy.text'></div>
          </div>
          <a :href='`#${slidesNames[4]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a>
        </section>
        <!-- Share -->
        <section class='section'>
          <div class="result-share">
            <h1 class='title'>Compartilhe seu resultado</h1>
            <div class="networks-social">
              <a href="#" @click.prevent="shareFaceBook">Facebook</a>
              <a :href="shareTwitterUrl" target="_blank">Twitter</a>
              <a :href="shareLinkedinUrl" target="_blank">Linkedin</a>
            </div>
          </div>
          <div class="footer-link">
            <a href="https://transformacaodigital.com/contato" target="_blank">Contate-nos</a>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import Mobile from 'mobile-detect'
import { TweenMax } from 'gsap'
import Icon from './Icon'
import fullpage from './../../static/js/javascript.fullPage.min'
import Abstract from './../assets/img/bg-abstract.jpg'
import AbstractFloat from './../assets/img/abstract-float.png'

var isMobile = false;

if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
   isMobile = true;
};

/* eslint-disable max-len */
export default {
  name: 'result',
  components: { Icon },
  data() {
    return {
      slidesNames: ['final', 'geral', 'categoria1', 'categoria2', 'compartilhe'],
      nextScreen: '/result',
      initResults: {
        td_score_understanding: 0,
        td_score_people: 0,
        td_score_process: 0,
        td_score_customer_experience: 0,
        td_score_strategy: 0,
        td_score_overall: 0,
      },
      results: {
        ...this.$store.state.results,
      },
      resultText: {
        overall: { text: '', title: '' },
        people: { text: '', title: '' },
        process: { text: '', title: '' },
        customer_experience: { text: '', title: '' },
        strategy: { text: '', title: '' },
      },
      dataResultText: {
        overall: [
          { maxScore: 20, title: 'Ainda temos um longo caminho pela jornada do digital', text: '<p>Ainda temos um longo caminho pela Transformação Digital. Mas não desanime!</p><p>Ser digital exige dedicação de toda a equipe, da direção ao estagiário. Um esforço coletivo para superar processos antigos e enferrujados, criar cultura e mindset digital, compartilhar constantemente informações para que as equipes trabalhem juntas em prol das metas da empresa e desenvolver ou contratar talentos para guiar a Transformação da empresa."</p>' },
          { maxScore: 40, title: 'Vemos transformações no horizonte...', text: '<p>A sua empresa entende o impacto da Transformação Digital no mercado, mas ainda precisa definir um plano de ação para se adaptar às mudanças.</p><p>Promover ferramentas digitais para a otimização dos processos, dar espaço para talentos digitais e, principalmente, estimular a cultura digital em sua empresa, podem ser os primeiros passos para se transformar.</p>' },
          { maxScore: 60, title: 'Ser digital já se tornou uma meta tangível', text: '<p>O digital já faz parte da rotina da empresa, seja nos processos ou nas entregas. Acredite, você já está à frente de muita gente!</p><p>Porém, esse é só o começo. Busque formas de implementar o digital em todos os processos da empresa, independente do setor, e cuide para que todos os touchpoints entre empresa-consumidor estimulem experiências únicas e alinhadas às expectativas do cliente.</p><p>Lembre de habilitar seus colaboradores para se tornarem talentos digitais e continue construindo sua cultura digital junto com toda a equipe.</p>' },
          { maxScore: 80, title: 'Sua jornada digital está quase completa', text: '<p>Sorria, a sua empresa é digital. Como a Transformação é uma jornada contínua, é importante que agora você habilite os talentos digitais para se tornarem líderes e promoverem inovações constantes - sem nunca esquecer de entender as expectativas dos consumidores para promover experiências novas e únicas.</p><p>Aproveite o cenário favorável para estimular ainda mais a cultura digital da empresa através do trabalho colaborativo e da exposição dos resultados digitais alcançados pela equipe até aqui.</p>' },
          { maxScore: 100, title: 'O seu DNA é digital', text: '<p>Ser digital é ser mutável e estar sempre pronto para novas adaptações - exatamente o caminho que a sua empresa está seguindo no cenário atual!</p><p>Não descanse e continue buscando e habilitando líderes e talentos digitais, além de tecnologias, para continuar fortalecendo a cultura digital e exceder as expectativas de experiência do consumidor.</p><p>Em pouco tempo, sua empresa será líder digital do seu setor de atuação.</p>' },
        ],
        people: [
          { maxScore: 20, title: 'Antes de entender a Transformação, entenda as pessoas', text: '<p>Todas as disrupções que vêm acontecendo se dão por conta de líderes que entenderam isso e utilizam tecnologias para liberar todo o potencial humano de seus colaboradores e consumidores.</p><p>Muitas vezes, o primeiro passo para tudo isso acontecer é dado pelo líder da empresa, mas nada impede que outros funcionários façam isso. Tudo pode depender de você!</p>' },
          { maxScore: 40, title: 'Entenda que a Transformação Digital é sobre pessoas, não tecnologia', text: '<p>Acredite, são os seus colaboradores que vão fazer a Transformação Digital da sua empresa acontecer, não apenas a tecnologia.</p><p>Construa e compartilhe com todos os colaboradores uma nova cultura digital e certifique-se de que as pessoas estão sendo habilitadas para os novos processos.</p>' },
          { maxScore: 60, title: 'Cortinas abertas para os protagonistas do show', text: '<p>Sua empresa entende o papel de destaque das pessoas na Transformação Digital. Hora de desenvolver novas habilidades digitais em seus colaboradores para evoluir talentos que vão sustentar a cultura digital da empresa.</p>' },
          { maxScore: 80, title: 'Somos todos digitais', text: '<p>As pessoas são protagonistas da Transformação Digital e a sua empresa já sabe disso. Agora é hora de transformar seus talentos digitais em líderes de setores para estimular a inovação contínua e o fortalecimento da cultura digital.</p>' },
          { maxScore: 100, title: 'Todo o potencial humano foi liberado', text: '<p>Sua empresa entende a importância de pessoas liderando o mundo digital e estimula sua evolução na Transformação Digital.</p><p>Continue desenvolvendo um trabalho dedicado a evoluir as habilidades digitais e de liderança dos seus colaboradores para estar sempre pronto para as novas adaptações."</p>' },
        ],
        process: [
          { maxScore: 20, title: 'Cuidado com a extinção...', text: '<p>Sua empresa ainda mantém processos analógicos que estão enraízados em modelos de negócios tradicionais, enquanto empresas que estão passando pela sua Transformação Digital utilizam processos digitais realizados de forma colaborativa entre todos os setores.</p><p>Repense os processos buscando metodologias ágeis e alinhadas com o digital para começar sua transformação.</p>' },
          { maxScore: 40, title: 'Run, Forrest, Run!', text: '<p>Sua empresa começou a agilizar seus processos, mas ainda tem um longo caminho para percorrer.</p><p>Busque tecnologias que vão automatizar processos repetitivos para que sua equipe possa focar sua inteligência no core-business.</p>' },
          { maxScore: 60, title: 'Halfway there...', text: '<p>Tudo está caminhando mais rápido do que o normal dentro da sua empresa. Os colaboradores estão percorrendo o caminho da Transformação Digital através de ferramentas e processos mais ágeis.</p><p>Os próximos passos consistem em traçar metas a serem alcançadas através do digital e buscar metodologias que vão facilitar as adaptações que ainda estão por vir.</p>' },
          { maxScore: 80, title: 'A todo vapor', text: '<p>Processos digitais já fazem parte de toda a empresa. Sua jornada pela Transformação Digital já está bem adiantada, e é justamente essa a hora de acelerar o passo para não perder o ritmo.</p><p>Estimule o trabalho colaborativo das equipes em busca das metas traçadas e potencialize os processos através de novas ferramentas digitais que atendam às mudanças constantes do mercado digital.</p>' },
          { maxScore: 100, title: 'Atingimos a velocidade da luz', text: '<p>Os processos da sua empresa já estão adptados ao modelo digital de trabalho. As equipes buscam constante evolução e colaboram entre si para que a jornada da Transformação Digital seja contínua.</p><p>Agora, é necessário ficar atento às novas tecnologias e tendências de mercado para novas adaptações, além de implementar de forma muito ágil qualquer mudança que se veja necessária.</p>' },
        ],
        customer_experience: [
          { maxScore: 20, title: '"Experiência do Cliente" é o que deve estar escrito em todos os memorandos da sua empresa', text: '<p>Entender sua força no atual cenário digital é o caminho para se manter relevante e, mais do que isso, não afundar.</p><p>Comece entendendo melhor os hábitos e as expectativas dos consumidores para redesenhar a jornada de compra de forma que todo o contato feito com sua empresa ofereça exepriências únicas para quem está do outro lado.</p>' },
          { maxScore: 40, title: 'Não é à toa que você tem dois ouvidos e apenas uma boca', text: '<p>Sua empresa já deu alguns passos em direção à uma jornada de compra baseada na experiência do consumidor.</p><p>Para impulsioná-la ainda mais, entenda os resultados alcançados até aqui através dos feedbakcs do público-alvo e busque melhorias para, pelo menos, cumprir as expectativas - e depois, sim, excedê-las.</p>' },
          { maxScore: 60, title: 'Test and Learn', text: '<p>Jornada de compra focada na experiência do consumidor já é uma realidade em sua empresa. Essa é a hora de testar novos produtos, serviços ou abordagens utilizando o digital para entender onde se está pisando e quais os próximos passos a serem dados.</p><p>Não desanime. Em vez disso, utilize a tecnologia a seu favor e estimule seus consumidores através do meio digital.</p>' },
          { maxScore: 80, title: 'Navegue novos mares', text: '<p>A experiência do consumidor é resultado da união entre metas e jornada de compra com este foco, e sua empresa parece entender isso.</p><p>A busca pela perfeitção continua através de um modelo de negócio adaptado aos consumidores da era digital e a constante melhoria dos produtos ou serviços oferecidos de acordo com as expectativas do cliente.</p>' },
          { maxScore: 100, title: 'Os seus clientes têm sorte por sua empresa existir no mercado', text: '<p>Investir continuamente em experiências únicas vai te ajudar a subir os degraus que levam à liderança do seu setor de mercado, mas isso exige total entendimento do consumidor - sejam seus hábitos ou suas expectativas. Traduzir suas expectativas em entregas potencializadas pelo digital - e mesmo rever completamente seu modelo de negócio para se alinhar - é o caminho que vai te levar além."</p>' },
        ],
        strategy: [
          { maxScore: 20, title: 'Não seja o Napoleão da era digital', text: '<p>Definir uma estratégia para passar pela Transformação Digital é o que vai manter sua empresa de portas abertas. O digital é um dividor de águas e, que não se adapta, acaba ficnado para trás.</p><p>Comece a sua jornada criando uma estrutura que sustente processos digitais para, então, criar e percorrer metas para a Transformação da sua empresa.</p>' },
          { maxScore: 40, title: 'Dividir é multiplicar', text: '<p>O primeiro passo foi dado, sua empresa está definindo uma estratégia para passar pela Transformação Digital. É importante lembrar de ter o digital em primeiro plano em todos os próximos passos.</p><p>Faça o possível para que todos da empresa conheçam a estratégia definida, abra as portas para que todos os colaboradores possam opiniar e otimizar a estratégia e colete dados que mensurem os resultados alcançados para entender se tudo está alinhada às metas da empresa.</p>' },
          { maxScore: 60, title: 'Aposte no seu time', text: '<p>A estratégia digital da sua empresa já foi colocada em prática. Para acelerá-la, crie um time dedicado à Transformação e liderado por algum talento digital.</p><p>Não esqueça de sempre disponibilizar as informações para toda a empresa, de forma a estimular a colaboração de todos em prol das mudanças digitais.</p>' },
          { maxScore: 80, title: 'Siga o plano', text: '<p>Sua empresa possui uma estratégia digital consistente. Este é o momento para buscar iniciativas digitais que auxiliem o alcance das metas da empresa para, finalmente, ter o digital como core-business de toda a operação.</p><p>Neste estágio onde o digital já é muito ativo dentro da empresa, a preocupação com a segurança dos dados deve ser máxima para que nenhuma informação caia em mãos externas.</p>' },
          { maxScore: 100, title: 'Parabéns por dominar a arte da guerra digital', text: '<p>A estratégia digital da sua empresa está alinhada com as disrupções que vêm acontecendo diariamente através da Transformação Digital. Hora de dar deixar sua segurança ainda mais robusta e buscar novas e maiores metas para ir além dos concorrentes através do digital.</p>' },
        ],
      },
      faceBook: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    window.$loadImages([Abstract, AbstractFloat]).then(() =>
      next()
    )
  },
  mounted() {
    /* eslint-disable */
    window.fbAsyncInit = () => {
      FB.init({
        appId      : '398443737018854',
        xfbml      : true,
        version    : 'v2.12'
      });
      FB.AppEvents.logPageView();
      this.faceBook = FB;
    }

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/pt_BR/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    /* eslint-enable */

    this.processResultText()
    const logo = document.getElementById('headerLogo')

    if (isMobile) {
      const keys = Object.keys(this.results);
      for (let i = 0; i < keys.length; i += 1) {        
        this.initResults[keys[i]] = this.results[keys[i]]
      }
    }

    isMobile && this.animateNumbers([
      "td_score_understanding",
      "td_score_people",
      "td_score_process",
      "td_score_customer_experience",
      "td_score_strategy",
      "td_score_overall"
    ], false)

    !isMobile && fullpage.initialize('#fullpage', {
      anchors: this.slidesNames,
      navigation: false,
      scrollBar: true,
      afterLoad: (anchor) => {
        switch (anchor) {
          case this.slidesNames[0]:
            this.animateNumbers(['td_score_overall'])
            break
          case this.slidesNames[1]:
            this.animateNumbers([
              'td_score_people',
              'td_score_process',
              'td_score_customer_experience',
              'td_score_strategy'
            ], false)
            break
          case this.slidesNames[2]:
            this.animateNumbers([
              'td_score_people',
              'td_score_process'
            ])
            break
          case this.slidesNames[3]:
            this.animateNumbers([
              'td_score_customer_experience',
              'td_score_strategy'
            ])
            break
        }
      },
      onLeave: (index, nextIndex) => {
        if (nextIndex === this.slidesNames.length) {
          logo.style.animationName = 'fade-to-bottom'
        } else
          logo.style.animationName = 'fade-to-bottom-reverse'
      }
    })
  },
  computed: {
    mobile() {
      return !!new Mobile(window.navigator.userAgent).phone()
    },
    shareLinkedinUrl() {
      const url = encodeURI('https://score.transformacaodigital.com/');
      const text = encodeURI(`Meu resultado foi ${this.initResults.td_score_overall}% - "${this.resultText.overall.title}". Descubra o seu: ${url}`);
      return `https://www.linkedin.com/shareArticle?url=${url}&summary=${text}`
    },
    shareTwitterUrl() {
      const text = encodeURI(`Meu resultado foi ${this.initResults.td_score_overall}% - "${this.resultText.overall.title}". Descubra o seu:`);
      const url = encodeURI('https://score.transformacaodigital.com/');
      const hashtags = encodeURI('TransformaçãoDigital,MaturidadeDigital,TDScore');
      return `https://twitter.com/share?url=${url}&hashtags=${hashtags}&text=${text}`
    }
  },
  methods: {
    shareFaceBook() {
      /* eslint-disable */
      console.log('-- faceBook');
      console.log(this.faceBook);
      console.log('-- FB');
      console.log(FB);
      FB.ui({
        method: 'share',
        href: 'http://tdscore.herokuapp.com/',
        hashtag: '#tdscore',
        quote: 'Teste quote'
      }, (response) => {
        console.log(response);
      });
      /* eslint-enable */
    },
    processResultText() {
      const keys = Object.keys(this.dataResultText);
      for (let i = 0; i < keys.length; i += 1) {
        this.scoreText(keys[i])
      }
    },
    scoreText(score) {
      const scoreField = this.results[`td_score_${score}`]
      for (let i = 0; i < 5; i += 1) {
        const dataText = this.dataResultText[score][i]
        if (scoreField <= dataText.maxScore) {
          this.resultText[score] = {
            text: dataText.text,
            title: dataText.title
          }
          break
        }
      }
    },
    animateNumbers(fields, reset = true) {
      const optionFields = []
      for (let i = 0; i < fields.length; i += 1) {
        if (reset) this.initResults[fields[i]] = 0
        Object.assign(optionFields, { [fields[i]]: this.results[fields[i]] })
      }
      TweenMax.to(this.initResults, 1, {
        ...optionFields,
        onUpdate: () => {
          for (let i = 0; i < fields.length; i += 1) {
            this.initResults[fields[i]] = Math.ceil(this.initResults[fields[i]])
          }
        },
      });
    },
    widthPercentage(value) {
      return `width:${value}%`
    }
  }
};
</script>

<style lang="scss" scoped>
  .result-page {
    .fullpage-wrapper {
      width: 100%;
      .section {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
    .result-bar {
      color: white;
      .description {
        padding: 0 25%;
        font-size: 20px;
        letter-spacing: 1px;
        padding-bottom: 40px;
        @media (max-width: 576px) {
          padding: 0 15px 42px;
        }
      }
      .categories-bars {
        display: flex;
        align-items: center;
        margin: 0 auto;
        flex-direction: column;
        width: 80%;
        @media (max-width: 576px) {
          width: 100%;
        }
      }
      .category-bar {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        text-transform: uppercase;
        letter-spacing: 2px;
        margin-bottom: 24px;
        .category {
          margin-top: 3px;
          text-align: right;
          width: 160px;
          @media (max-width: 576px) {
            text-align: left;
            margin-left: 15px;
            width: 85px;
          }
        }
        .progress {
          background-color: rgba(black, .2);
          flex: 1;
          margin: 0 16px;
          height: 16px;
          .fill {
            height: 100%;
            width: 0;
            background-color: rgba(white, .5);
            transition: width .5s;
            will-change: width;
          }
        }
        .number-percentage {
          border-radius: 2px;
          box-shadow: 0px 21px 25.23px 3.77px rgba(0, 0, 0, 0.1), 0px 0px 17px 0px rgba(0, 0, 0, 0.1);
          background-color: rgba(white,.1);
          padding: 2px 4px;
          border-color: #656D72;
          letter-spacing: 2px;
          text-indent: 2px;
          font-size: 18px;
          margin-right: 12%;
        }
      }
    }
    .result-percentage {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .title-main {
        position: relative;
        z-index: 1;
        color: white;
        font-size: 24px;
        font-weight: normal;
        text-transform: uppercase;
        letter-spacing: 5px;
        @media (max-width: 576px) {
          margin: 0 15px;
        }
      }
      &.result-big {
        height: 100vh;
        width: 100vw;
        .title-main {
          padding: 0 100px;
          font-size: 42px;
          letter-spacing: 10px;
          @media (max-width: 700px) {
            padding: 0 15px;
          }
        }
        .number-float {
          font-size: 300px;
        }
      }
    }
    .number-float {
      font-family: 'PFDin';
      position: absolute;
      margin: 0 auto;
      font-size: 200px;
      color: rgba(white, .3);
      text-shadow: 0 0 20px rgba(white, .5);
      -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(black), color-stop(85%, transparent));
      mask-image: linear-gradient(to bottom, black, transparent 85%);
    }
    .result-categories {
      @media (max-width: 576px) {
        flex-direction: column;
      }
    }
    .result-category {
      display: flex;
      flex-direction: column;
      text-align: center;
      color: white;
      width: 38%;
      &:first-child {
        margin-top: 15%;
        margin-bottom: auto;
      }
      &:last-child {
        margin-bottom: 18%;
        margin-top: auto;
      }
      @media (max-width: 576px) {
        width: 100%;
        margin: 110px 0 0 0 !important;
      }
      .category {
        font-size: 22px;
        text-transform: uppercase;
        letter-spacing: 15px;
        position: relative;
        margin: 0 auto 35px;
        @media (max-width: 576px) {
          letter-spacing: 8px;
          transform: translateX(8px);
        }
        &:before {
          content: "";
          position: absolute;
          top: -30%;
          left: -18px;
          right: 0;
          bottom: 0;
          padding: 0 10px;
          background-color: rgba(white, .102);
          height: 160%;
          width: 100%;
        }
        &:after {
          content: "";
          position: absolute;
          bottom: -45px;
          left: -15px;
          right: 0;
          margin: 0 auto;
          display: block;
          width: 1px;
          height: 20px;
          background-color: white;
        }
      }
      .result-percentage {
        height: 180px;
        @media (max-width: 576px) {
          height: 220px;
        }
      }
      .result-description {
        text-align: left;
        font-size: 20px;
        line-height: 26px;
        letter-spacing: 1px;
        padding: 0 25px;
        /deep/ > p:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .result-share {
    text-align: center;
    .title {
      color: white;
      text-transform: uppercase;
      font-weight: normal;
      letter-spacing: 20px;
      position: relative;
      margin-bottom: 100px;
      @media (max-width: 576px) {
        margin-left: 20px;
        margin-top: 100px;
        margin-bottom: 60px;
        letter-spacing: 12px;
      }
      @media (min-width: 576px) and (max-width: 991px) {
        letter-spacing: 10px;
        margin-bottom: 80px;
      }
      &:after {
        content: "";
        position: absolute;
        bottom: -60px;
        left: -20px;
        right: 0;
        margin: 0 auto;
        display: block;
        width: 1px;
        height: 30px;
        background-color: white;
      }
    }
    .networks-social {
      display: flex;
      justify-content: center;
      @media (max-width: 576px) {
        flex-direction: column;
        padding: 24px 0;
      }
      @media (min-width: 576px) and (max-width: 991px) {
        flex-direction: column;
      }
      a {
        text-transform: uppercase;
        letter-spacing: 5px;
        text-indent: 5px;
        font-size: 16px;
        margin: 0 20px 0 0;
        background-color: rgba(black, .05);
        color: white;
        padding: 40px 70px;
        display: inline-block;
        text-decoration: none;
        transition: background .3s;
        &:hover {
          background: linear-gradient(to left, rgba(white, .2), transparent);
        }
        @media (max-width: 576px) {
          width: 100%;
          padding: 40px 0;
          margin: 10px 0;
        }
        @media (min-width: 576px) and (max-width: 991px) {
          margin: 12px 0;
        }
      }
    }
  }
  .footer-link {
    justify-content: center;
    @media (max-width: 576px) {
      position: relative;
      a {
        flex: 1;
        margin-top: 40px;
        padding: 40px 0;
        text-align: center;
      }
    }
  }
  .is-mobile {
    #fullpage {
      display: flex;
      flex-direction: column;
    }
    &.bg-abstract {
      background: none;
    }
  }
</style>

<style lang="scss">
  #headerLogo {
    animation-duration: 1s;
    animation-fill-mode: forwards;
  }
  @keyframes fade-to-bottom {
    49% {
      bottom: initial;
    }
    50% {
      opacity: 0;
      top: initial;
      bottom: 0;
    }
    100% {
      top: initial;
      bottom: 0;
    }
  }
  @keyframes fade-to-bottom-reverse {
    0% {
      top: initial;
      bottom: 0;
    }
    49% {
      bottom: 0;
    }
    50% {
      opacity: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Result.vue